module.exports = "<svg width=\"5\" height=\"8\" viewBox=\"0 0 5 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 7.06L3.09 4 0 .94.95 0 5 4 .95 8\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/small_caret_right.svg
// module id = 827
// module chunks = 0